import r from "@/js/route";
import httpClient from '@/js/services/http-client';

export default class NotificationService {
    axios
    constructor() {
        this._axios = httpClient;
    }

    async get() {
        const {data} = await this._axios.get(r('users.notifications'));
        return data;
    }

    async setRead(notificationId) {
        const {data} = await this._axios.put(r('users.notification.read', notificationId));
        return data;
    }

    async setUnRead(notificationId) {
        const {data} = await this._axios.put(r('users.notification.unread', notificationId));
        return data;
    }

    async setAllRead() {
        const {data} = await this._axios.put(r('users.notifications.read'));
        return data;
    }

}
